import { useState } from "react";
import { Upload, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, API, formatApiErrorDetail } from "../lib/api";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/** Resolve an absolute URL for a path returned by /api/admin/upload */
export function resolveUploadUrl(url) {
  if (!url) return "";
  if (/^https?:\/\//i.test(url)) return url;
  return `${BACKEND_URL}${url}`;
}

export default function ImageUploadField({ value, onChange, testid }) {
  const [busy, setBusy] = useState(false);

  const onPick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const token = localStorage.getItem("nccc_token");
      const res = await fetch(`${API}/admin/upload`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: fd,
      });
      const data = await res.json();
      if (!res.ok) throw new Error(formatApiErrorDetail(data.detail));
      onChange(data.url);
      toast.success("Uploaded.");
    } catch (err) {
      toast.error(err.message || "Upload failed");
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };

  return (
    <div className="flex items-stretch gap-2" data-testid={testid}>
      <input
        type="text"
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        placeholder="paste URL or upload →"
        className="nccc-input flex-1"
        data-testid={`${testid}-url`}
      />
      <label
        className="nccc-btn cursor-pointer"
        style={{ padding: "10px 14px" }}
        data-testid={`${testid}-upload-label`}
      >
        {busy ? <Loader2 className="animate-spin" size={14} /> : <Upload size={14} />}
        <input
          type="file"
          accept="image/*,audio/*"
          onChange={onPick}
          className="hidden"
          data-testid={`${testid}-upload-input`}
        />
      </label>
      {value && (
        <a
          href={resolveUploadUrl(value)}
          target="_blank"
          rel="noreferrer"
          className="nccc-btn nccc-btn-ghost"
          style={{ padding: "10px 14px" }}
        >
          ↗
        </a>
      )}
    </div>
  );
}
